module Internal.Util where

import Common

justIf :: forall a. Boolean -> a -> Maybe a
justIf true a = Just a
justIf false _ = Nothing
